
/* styles */
require("!!../../../../node_modules/.2.1.0@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/.11.1.4@vue-loader/lib/style-rewriter?{\"id\":\"data-v-258dabdf\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?{\"sourceMap\":true}!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=styles&index=0!./Widget.vue")

var Component = require("!../../../../node_modules/.11.1.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=script&index=0!./Widget.vue"),
  /* template */
  require("!!../../../../node_modules/.11.1.4@vue-loader/lib/template-compiler?{\"id\":\"data-v-258dabdf\"}!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=template&index=0!./Widget.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/packages/widget/src/Widget.vue
// module id = 228
// module chunks = 0